

export class AppConstants 
{
    static VERSION = "2.12.54";
    
    static UCTX_KEY = "userContext";
    static CURRENTLY_EMBODYING = "CURRENTLY_EMBODYING";
    static SRM_TOKEN_NAME = "X-SRM-Token";
    static TITLE_APP = 'Report Manager';
    static SESSION_EXPIRED_MSG = "Sessione scaduta: rieseguire il login!";
    static TIMEOUT_EXPIRED_MSG = "Timeout scaduto: Il servizio ha impiegato troppo tempo a rispondere!";
    static SESSION_CLOSED_MSG = "Sessione terminata correttamente!";
    static FREQUENCY_COUNT_REQUEST_TO_BE_APPROVED = 15 * 60000; // 15 minuti
    
    static ITA_CALENDAR_CONF = 
    {
        firstDayOfWeek: 1,
        dayNames: ["Domenica", "Lunedi", "Martedi", "Mercoledi", "Giovedi", "Venerdi", "Sabato"],
        dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
        dayNamesMin: ["Do","Lu","Ma","Me","Gi","Ve","Sa"],
        monthNames: [ "Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre" ],
        monthNamesShort: [ "Gen", "Feb", "Mar", "Apr", "Mag", "Giu","Lug", "Ago", "Set", "Ott", "Nov", "Dic" ]
    };
    
    static formatDuration(hours:number, minutes: number): string
    {
        var result = ""
        if(hours != 0) {
            result += hours + " h";
            if(minutes != 0) {
                result += " " + minutes + " m";
            }
        }
        else if(minutes != 0) {
            result += minutes + " m";
        }
        return result;
    }
    
    static parseDate(dateString): Date
    {
        if(dateString == null || dateString == "" || typeof(dateString) == 'undefined') {
            return null;
        }
        let tmp = dateString.split("/");
        let day = tmp[0];
        let month = tmp[1];
        let year = tmp[2];
        return new Date(Date.parse(year + "-" + month + "-" + day + "T00:00:00"));
    }
    
    static isToday(date: Date): boolean
    {
        let today = new Date();
        if(today.getDate() == date.getDate() && today.getMonth() == date.getMonth() && 
           today.getFullYear() == date.getFullYear()) {
            return true;
        }
        return false;
    }
    
    static hashCode(str: string) : number 
    {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
           hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return hash;
    } 

    static intToRGB(i: number) : string
    {
        var c = (i & 0x00FFFFFF)
            .toString(16)
            .toUpperCase();

        return "#" + ("00000".substring(0, 6 - c.length) + c);
    }
    
    static urlForNoCache(url: string) : string {
        return url + ((url.indexOf('?') > 0) ? '&ts' : '?ts=') + Date.now();
    }

    /**
     * Costruisce un body application/x-www-form-urlencoded.
     * Non si usa URLSearchParams di @angular/http perche' il suo encoder
     * ri-converte %2B nel carattere '+': nel body form-urlencoded il server
     * lo decodifica come spazio, alterando il valore inviato (es. le password
     * che contengono '+').
     */
    static formUrlEncode(params: { [key: string]: string }) : string {
        let parts: string[] = [];
        for(let key in params) {
            if(params.hasOwnProperty(key)) {
                let value = params[key];
                parts.push(encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value));
            }
        }
        return parts.join("&");
    }

    /**
     * Suggerimenti per i p-autoComplete: tiene le voci che contengono il testo
     * digitato in uno qualsiasi dei campi, mettendo prima quelle in cui un campo
     * inizia con il testo (con autoHighlight, Invio sceglie la prima voce).
     */
    static filterSuggestions<T>(items: T[], query: string, fields: (item: T) => string[]): T[] {
        let text = query.toLowerCase();
        let startsWith: T[] = [];
        let contains: T[] = [];
        items.forEach(item => {
            let positions = fields(item).map(field => field ? field.toLowerCase().indexOf(text) : -1);
            if (positions.some(position => position == 0)) {
                startsWith.push(item);
            } else if (positions.some(position => position > 0)) {
                contains.push(item);
            }
        });
        return startsWith.concat(contains);
    }
}


// WEBPACK FOOTER //
// ./src/app/core/app.constants.ts